import React from 'react';
import Typography from "@material-ui/core/Typography/Typography";

import ActionButtons from "../../common/ActionButtons/ActionButtons";
import Controls from "../../common/Controls/Controls";
import PropTypes from 'prop-types';

import {InfoWrapper} from "./Info.sc";

const Info = (props) => {

    const {
        lat, lng, verticalScale, baseHeight, waterDrop, boxSize, boxScale, modelScale, downloadAvailable, loadingComplete,
        handleOnClickGenerate, handleOnClickDownload, handleBoxSizeChange, handleLocationChange,
        handleBoxScaleChange, handleWaterDropChange, handleBaseHeightChange, handleVerticalScaleChange,
        handleModelScaleChange, showDownloadButton
    } = props;

    return (
        <InfoWrapper>
            <Typography variant="title" color="inherit">
                Settings
            </Typography>
            <Controls
                verticalScale={verticalScale}
                baseHeight={baseHeight}
                waterDrop={waterDrop}
                lat={lat}
                lng={lng}
                boxSize={boxSize}
                boxScale={boxScale}
                modelScale={modelScale}
                handleBoxSizeChange={handleBoxSizeChange}
                handleLocationChange={handleLocationChange}
                handleBoxScaleChange={handleBoxScaleChange}
                handleWaterDropChange={handleWaterDropChange}
                handleBaseHeightChange={handleBaseHeightChange}
                handleVerticalScaleChange={handleVerticalScaleChange}
                handleModelScaleChange={handleModelScaleChange}
            />
            <ActionButtons
                handleOnClickGenerate={handleOnClickGenerate}
                handleDownload={handleOnClickDownload}
                loadingComplete={loadingComplete}
                downloadAvailable={downloadAvailable}
                showDownloadButton={showDownloadButton}
            />
        </InfoWrapper>
    );
};

Info.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    boxSize: PropTypes.number.isRequired,
    verticalScale: PropTypes.number.isRequired,
    baseHeight: PropTypes.number.isRequired,
    waterDrop: PropTypes.number.isRequired,
    boxScale: PropTypes.number.isRequired,
    modelScale: PropTypes.number.isRequired,

    loadingComplete: PropTypes.bool.isRequired,
    downloadAvailable: PropTypes.bool.isRequired,
    showDownloadButton: PropTypes.bool.isRequired,

    handleBoxSizeChange: PropTypes.func.isRequired,
    handleLocationChange: PropTypes.func.isRequired,
    handleBoxScaleChange: PropTypes.func.isRequired,
    handleWaterDropChange: PropTypes.func.isRequired,
    handleBaseHeightChange: PropTypes.func.isRequired,
    handleVerticalScaleChange: PropTypes.func.isRequired,
    handleOnClickGenerate: PropTypes.func.isRequired,
    handleOnClickDownload: PropTypes.func.isRequired,
    handleModelScaleChange: PropTypes.func.isRequired
};

export default Info;



// WEBPACK FOOTER //
// ./src/desktop/Info/Info.js